module.exports = __webpack_public_path__ + "static/media/ProgrammingImg.071a37cf.png";